<template>
  <!--ToDO: add logic to button -->
  <button class="button-signup button-primary btn-block align-items-stretch justify-content-center d-flex">
    <div>{{site.name}} Issue Alert Sign Up</div>
    <div class="icon-wrapper align-self-center"><i class="icon icon-arrow-right"></i></div>
  </button>
</template>

<script>
  export default {
    name: 'sidebarSignupButton',
    data () {
      return {
        site: {
          name: process.env.SITE_NAME,
          mobileSiteCoverUrl: 'MobileSiteCover.png'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .button-signup {
    font-size: 16px;
    margin: 0 0 $spacing-large;
    min-height: 45px;
    .icon-wrapper {
      width: 15%;
      min-width: 20px;
      text-align: right;
    }
  }
  @media (min-width: $breakpoint-md) and (max-width: $breakpoint-xl) {
    .button-signup {
      font-size: 14px;
      padding: 5px 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarSignUpButtonComponent.vue?88c8ce22